<template>
    <div :class="'kanban-column-wrapper ' + borderTopClass">
        <div class="kanban-column-header">
            <div class="kanban-title">{{ title }}</div>
            <div v-if="orderStateId == 4" class="save-queues-wrapper">
                <b-button v-show="canSaveQueues" variant="success" class="save-queues float-right my-2" @click="saveQueues"
                    :disabled="!queueEditActive">Guardar colas</b-button>
            </div>
        </div>
        <div class="product-line-kanbans" v-for="productionLine in filteredProductionLines">
            <KanbanBoard :orderStateId="orderStateId" :productionLine="productionLine" :dragOptions="dragOptions"
                :kanbanGroup="kanbanGroup" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KanbanBoard from "./KanbanBoard";
import axios from "axios";
import { FilterTypes } from "./FilterTypes";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";
import PermissionsConsts from "../../common/permissions";

export default {
    name: "KanbanBoardList",
    components: { KanbanBoard },
    props: {
        title: String,
        orderStateId: Number,
        dragOptions: Object,
        kanbanGroup: String
    },
    methods: {
        ...mapActions('production_control', ['setQueueEditActive']),
        saveQueues(){
            const queues = this.kanban.map(k => ({
                productionLineId: k.id,
                orderReferenceIds: k.orderReferencesQueued ? k.orderReferencesQueued.map(o => o.id) : []
            }));
            // const result = {
            //     json: JSON.stringify(queues)
            // };
            axios.post(`/api/production-control/queue-order `, { productionLineQueueOrders: queues })
                .then(res => {
                    this.setQueueEditActive(0);
                    showCustomSuccessSweetAlert('Colas guardadas correctamente');
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
    },
    computed: {
        ...mapGetters(['productionLines']),
        ...mapGetters('production_control', ['kanban', 'filterByName', 'queueEditActive']),
        ...mapGetters(['userPermissions','userHasPermission']),
        allowedProductionLines() {
            return this.filterByName(FilterTypes.PRODUCTION_LINES);
        },
        filteredProductionLines() {
            return this.allowedProductionLines && this.allowedProductionLines.length > 0
                ? this.productionLines.filter(pl => this.allowedProductionLines.includes(pl.id))
                : this.productionLines;
        },
        borderTopClass() {
            let borderTopClasses = ['in-production-border-top', 'finished-border-top', 'pending-border-top']
            return borderTopClasses[this.orderStateId - 2]
        },
        canSaveQueues(){
            return this.userHasPermission(PermissionsConsts.PLANNER_QUEUE_ORDER_UPDATE);
        }
    }
}
</script>